export default {
  path: 'summary-profit',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Summary Profit Project',
      component: () => import('@/views/menus/summaryProfit/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
